import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { PillComponent } from '../../../../../shared/components/pill/pill.component';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { BehaviorSubject } from 'rxjs';
import { Policy } from '../../../models/Policy';
import { DataTableColumn } from '../../../../../shared/components/data-table/DataTableColumn.model';

@Component({
  selector: 'app-shared-policy-table',
  templateUrl: './shared-policy-table.component.html',
  styleUrls: ['./shared-policy-table.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PillComponent,
    MatTableModule,
    MatIcon,
    MatButtonModule,
    MatTooltipModule,
    MatExpansionModule,
    MatProgressSpinner
  ]
})
export class SharedPolicyTableComponent implements OnInit {

  @Input() component!: string;
  @Input() set dataSource(value: MatTableDataSource<any>) {
    this._dataSource = value;
  };

  @Input() displayedColumns!: DataTableColumn[];
  @Input() tableLength?: number;
  @Input() displayLoadingIndicator!: BehaviorSubject<boolean>;
  @Input() actionButtonText?: string;
  @Input() hidePointer: boolean = false;
  @Input() getStatusColor?: (status: string) => string;
  @Input() propertyHasPrimaryPolicy: boolean = false;

  @Output() actionClickedEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() editPolicyClickEvent = new EventEmitter<Policy>();
  @Output() updatePolicyClickEvent = new EventEmitter<Policy>();
  @Output() deletePolicyClickEvent = new EventEmitter<Policy>();
  @Output() selectPolicyClickedEvent = new EventEmitter<Policy>();

  _dataSource!: MatTableDataSource<any>;
  displayedColumnNames: string[] = [];
  selectedRowIndex: any;
  primaryPolicy: boolean = false;

  constructor() { }

  ngOnInit() {
    if (this._dataSource == null) {
      this.dataSource = new MatTableDataSource();
    }
    this.initTableColumns();
  }

  initTableColumns(): void {
    if (this.displayedColumns === null) {
      this.displayedColumns = [];
    }
    this.displayedColumnNames = this.displayedColumns.map(c => c.column);
  }

  onRowClick(row: any): void {
    this.selectedRowIndex = row;
  }

  onActionButtonClick(event: MouseEvent, row: any): void {
    event.stopPropagation();
    this.actionClickedEvent.emit(row);
  }

  onEditPolicyButtonClick(event: MouseEvent, row: any) {
    event.stopPropagation();
    this.editPolicyClickEvent.emit(row);
  }

  onUpdatePrimaryPolicyClick(event: MouseEvent, row: any) {
    event.stopPropagation();
    this.updatePolicyClickEvent.emit(row);
  }

  onDeletePolicyButtonClick(event: MouseEvent, row: any) {
    event.stopPropagation();
    this.deletePolicyClickEvent.emit(row);
  }

  onSelectPolicyButtonClick(event: MouseEvent, row: any): void {
    event.stopPropagation();
    this.selectPolicyClickedEvent.emit(row);
  }

  getColor(status: string) {
    if (this.getStatusColor) {
      return this.getStatusColor(status);
    } else {
      return '#d3d3d3'
    }
  }
}